import { render, staticRenderFns } from "./FormItemView.vue?vue&type=template&id=2595df98&scoped=true&"
import script from "./FormItemView.vue?vue&type=script&lang=js&"
export * from "./FormItemView.vue?vue&type=script&lang=js&"
import style0 from "./FormItemView.vue?vue&type=style&index=0&id=2595df98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595df98",
  null
  
)

export default component.exports